import type { AnnotationShape } from '@/features/comment-on-file';
import { ArrowShape } from './ArrowShape';
import { arrowMarkerId } from './ArrowShape.utils';
import { CircleShape } from './CircleShape';
import { PenShape } from './PenShape';
import { RectangleShape } from './RectangleShape';
import { TextHighlightShape } from './TextHighlightShape';

interface Props {
  shape: AnnotationShape;
  color: string;
  focused?: boolean;
  halo?: boolean;
  /** Parent SVG's rendered CSS pixel dimensions — accepted by all shape
   * renderers for a uniform call signature, though no current shape uses it. */
  boxSize?: { width: number; height: number } | null;
}

export function ShapeRenderer({ shape, color, focused, halo }: Props) {
  switch (shape.type) {
    case 'circle':
      return <CircleShape shape={shape} color={color} focused={focused} halo={halo} />;
    case 'rectangle':
      return <RectangleShape shape={shape} color={color} focused={focused} halo={halo} />;
    case 'arrow':
      return (
        <ArrowShape
          shape={shape}
          color={color}
          markerId={arrowMarkerId(color)}
          focused={focused}
          halo={halo}
        />
      );
    case 'pen':
      return <PenShape shape={shape} color={color} focused={focused} halo={halo} />;
    case 'text-highlight':
      return <TextHighlightShape shape={shape} color={color} focused={focused} />;
  }
}
